import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import getTheme from '../MuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

var LLRadioGroup = /*#__PURE__*/function (_Component) {
  _inherits(LLRadioGroup, _Component);

  var _super = _createSuper(LLRadioGroup);

  function LLRadioGroup() {
    _classCallCheck(this, LLRadioGroup);

    return _super.apply(this, arguments);
  }

  _createClass(LLRadioGroup, [{
    key: "render",
    value: function render() {
      var radioButtons = null;

      if (this.props.children instanceof Array) {
        radioButtons = this.props.children.map(function (c, i) {
          return /*#__PURE__*/React.createElement(RadioButton, _extends({}, c.props, {
            value: c.props.value,
            label: c.props.label,
            key: i
          }));
        });
      } else {
        radioButtons = [/*#__PURE__*/React.createElement(RadioButton, _extends({}, this.props.children.props, {
          value: c.props.value,
          label: c.props.label,
          key: 0
        }))];
      }

      return /*#__PURE__*/React.createElement(RadioButtonGroup, this.props, radioButtons);
    }
  }]);

  return LLRadioGroup;
}(Component);

_defineProperty(LLRadioGroup, "propTypes", {
  name: PropTypes.string,
  defaultSelected: PropTypes.string,
  style: PropTypes.object,
  onChange: PropTypes.func
});

_defineProperty(LLRadioGroup, "defaultProps", {
  style: {},
  name: null,
  defaultSelected: null,
  onChange: null
});

export { LLRadioGroup as default };